function calcHypotenuse(a, b) {
  return Math.sqrt(a * a + b * b);
}

function vwToPx(vw) {
  const windowWidth = window.innerWidth;
  return (vw / 100) * windowWidth;
}

function pxToVw(px) {
  const viewportWidth = window.innerWidth;
  const heightInVw = (px / viewportWidth) * 100;
  return heightInVw;
}

function vhToPx(vh) {
  const windowHeight = window.innerHeight;
  return (vh / 100) * windowHeight;
}

function pxToVh(px) {
  const viewportHeight = window.innerHeight;
  const heightInVh = (px / viewportHeight) * 100;
  return heightInVh;
}

function vwToVh(vw) {
  const inPx = vwToPx(vw);
  return pxToVh(inPx);
}

function vhToVw(vh) {
  const inPx = vhToPx(vh);
  return pxToVw(inPx);
}

function calcVhMinusVw(vhValue, vwValue) {
  const vhInPx = (vhValue / 100) * window.innerHeight;
  const vwInPx = (vwValue / 100) * window.innerWidth;
  const resultPx = vhInPx - vwInPx;
  const resultVw = (resultPx / window.innerWidth) * 100;
  return resultPx;
}

const isDesktop = () => {
  return window.innerWidth >= 1278;
};

const isTablet = () => {
  return window.innerWidth >= 768;
};

function formatMoneyUSD(cents) {
  return '$' + (cents / 100).toFixed(2) + ' USD';
}

const getYouTubeID = (url) => {
  const regExp = /^.*(youtu\.be\/|v=|\/v\/|embed\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
    ?.split('=')[1];
}

function getTrueOffsetLeft(el) {
  let x = 0;
  let current = el;

  while (current) {
    const rect = current.getBoundingClientRect();
    x += rect.left;
    const style = window.getComputedStyle(current);
    const transform = style.transform;

    if (transform && transform !== 'none') {
      const match = transform.match(/matrix\(([^)]+)\)/);
      if (match) {
        const matrixValues = match[1].split(', ');
        x += parseFloat(matrixValues[4]);
      }
    }

    current = current.offsetParent;
  }

  return x;
}

const isExternalLink = (href) => {
  try {
    const linkUrl = new URL(href, window.location.href);
    return linkUrl.origin !== window.location.origin;
  } catch (e) {
    return false;
  }
};

const createPath = (path) => {
  const isInternational = window.location.href.includes('international');
  let addedPath = '';
  if(isInternational){
    addedPath = 'en-international';
  }
  return addedPath + path;
}

const runTasks = (tasks) => {
  let i = 0;

  const next = () => {
    if (i >= tasks.length) return;
    tasks[i++]();
    requestAnimationFrame(next);
  };

  next();
};

const addTweensByFrames = ({
  timeline,
  items,
  createTween,
  batchSize = 1,
  onComplete
}) => {
  let i = 0;

  const next = () => {
    let count = 0;

    while (i < items.length && count < batchSize) {
      createTween(items[i], i);
      i++;
      count++;
    }

    if (i < items.length) {
      requestAnimationFrame(next);
    } else {
      onComplete?.();
    }
  };

  next();
};


const addSectionObserver = (section, animationCallback, isMobileAdded = true, offset = '50%') => {
  if (!isDesktop() && !isMobileAdded) return;
  if (section.offset().top < window.innerHeight * 0.7) {
    animationCallback();
  } else {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animationCallback();
          observer.disconnect();
        }
      });
      }, {
        rootMargin: `0px 0px ${offset} 0px`,
        threshold: 0
    });

    observer.observe(section.get(0));
  }
}

const stopScroll = (e) => {
  e.preventDefault();
};

const nextFrame = () => {
  return new Promise(r => requestAnimationFrame(r));
}


const addDotButtonAndClickHandlers = (emblaApi, dotsNode) => {
  let dotNodes = []
  console.log(emblaApi)
  const addDotBtnsWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<button class="product-media-slider-dot embla__dot" type="button"><div class="product-media-slider-dot-inner"><div class="product-media-slider-dot-inner-progress"></div></div></button>')
      .join('')

    const scrollTo = (index) => {
      emblaApi.scrollTo(index)
    }

    dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener('click', () => scrollTo(index), false)
    })
  }

  const toggleDotButtonsActive = () => {
    const previous = emblaApi.previousScrollSnap()
    const selected = emblaApi.selectedScrollSnap()
    gsap.to(dotNodes[previous].querySelectorAll('.product-media-slider-dot-inner'), {
      width: () => (isDesktop() ? '0.313vw' : isTablet() ? '0.651vw' : '1.389vw'),
      ease: 'tagInEasing',
      duration: 0.463,
    });
    gsap.to(dotNodes[selected].querySelectorAll('.product-media-slider-dot-inner'), {
      width: () => (isDesktop() ? '3vw' : isTablet() ? '6.25vw' : '13.333vw'),
      ease: 'tagInEasing',
      duration: 0.463,
    });/*
    dotNodes[previous].classList.remove('embla__dot--selected')
    dotNodes[selected].classList.add('embla__dot--selected')
    */
  }

  addDotBtnsWithClickHandlers()
  toggleDotButtonsActive()

  emblaApi
    .on('reinit', addDotBtnsWithClickHandlers)
    .on('reinit', toggleDotButtonsActive)
    .on('select', toggleDotButtonsActive)
}

const addAutoplayProgressListeners = (emblaApi, progressNode) => {
  const progressBarNodes = progressNode.querySelectorAll('.product-media-slider-dot-inner-progress');

  let animationName = ''
  let timeoutId = 0
  let rafId = 0
  const progressBarTLs = [];

  const autoplay = emblaApi?.plugins()?.autoplay
  if (!autoplay) return

  const timeUntilNext = autoplay.timeUntilNext()
  if (timeUntilNext === null) return

  progressBarNodes.forEach(function(progressBarNode, index){
    progressBarTLs[index] = gsap.fromTo(progressBarNode, {
        width: '0%'
      },{
        width: '100%',
        duration: timeUntilNext / 1000,
        ease: 'linear',
        paused: true
      })
  })

  const startProgress = (emblaApi) => {
    const selected = emblaApi.selectedScrollSnap();

    if(progressBarNodes[selected]){
      progressBarTLs[selected].play(0)
    }
  }

  const stopProgress = (emblaApi) => {
    const selected = emblaApi.selectedScrollSnap();

    if(progressBarNodes[selected]){
      progressBarTLs[selected].progress(0)
      progressBarTLs[selected].pause()
    }
  }

  startProgress(emblaApi);

  emblaApi
    .on('autoplay:timerset', startProgress)
    .on('autoplay:timerstopped', stopProgress)
}
